var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2536 14.9829C32.2536 14.9829 32.0094 13.2526 31.2573 12.4928C30.305 11.4929 29.2403 11.488 28.7519 11.4292C25.2551 11.1743 20.005 11.1743 20.005 11.1743H19.9953C19.9953 11.1743 14.7451 11.1743 11.2483 11.4292C10.7599 11.488 9.69528 11.4929 8.74293 12.4928C7.99082 13.2526 7.75152 14.9829 7.75152 14.9829C7.75152 14.9829 7.49756 17.017 7.49756 19.0463V20.9481C7.49756 22.9774 7.74663 25.0116 7.74663 25.0116C7.74663 25.0116 7.99082 26.7418 8.73805 27.5016C9.69039 28.5015 10.9407 28.4672 11.4974 28.575C13.4998 28.7662 20.0001 28.825 20.0001 28.825C20.0001 28.825 25.2551 28.8152 28.7519 28.5652C29.2403 28.5064 30.305 28.5015 31.2573 27.5016C32.0094 26.7418 32.2536 25.0116 32.2536 25.0116C32.2536 25.0116 32.5027 22.9823 32.5027 20.9481V19.0463C32.5027 17.017 32.2536 14.9829 32.2536 14.9829ZM17.4166 23.2568V16.2034L24.1709 19.7423L17.4166 23.2568Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.f890980c.svg";
export { ForwardRef as ReactComponent };